module.exports = __webpack_public_path__ + "img/pass.a5ae9712.svg";